module.exports = __webpack_public_path__ + "static/img/article.feb34f96.png";